var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"banner",style:({'backgroundImage':("url(" + (!_vm.$store.state.isMobile?_vm.item.picture:_vm.item.mobilepicture) + ")")}),attrs:{"href":_vm.item.link,"target":"_blank"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }